const add =
{
    agree       : 'Ajouter' ,
    description : 'Ajouter un nouvel enregistrement.' ,
    disagree    : 'Annuler' ,
    elements    : [] ,
    title       : 'Ajouter'
};

export default add ;